import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { InsightCount } from 'schemas/action/InsightCountSchema'

const IndexWidgetEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const entries = widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.flatMap(
    (result) => result.set
  )

  if (entries?.length === 0) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  return children
}

export default IndexWidgetEmptyResultGuard
